/* eslint-disable no-console */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { faker } from '@faker-js/faker';
import { MultiInfoCard } from 'components';
import { ChartCard } from 'components';
import { MapCard } from 'components';
import TableCard from 'components/Cards/TableCard';
import BarChart from 'components/Charts/BarChart';
import LineChart from 'components/Charts/LineChart';
import MultiChart from 'components/Charts/MultiChart';
import { colors } from 'theme/components/colors';
import {
  barDataWithBorderColorAndColorArray,
  ChartTypeFilters,
  daysLabels,
  homeCardsData,
  lineDataWithDefaultColors,
  MapValue1,
  MapValue3,
  monthsLabels,
  multiChartDefaultColorsLinesAndBars,
  tableFilters,
  testLabels,
  testTableData,
  testTableLabels,
} from 'utils/constants';

const lineData: ChartData[] = [
  {
    label: 'dataset 1',
    fill: {
      type: 'start',
    },
    values: daysLabels.map(() =>
      faker.datatype.number({ min: 0, max: 150000 }),
    ),
  },
];

const lineData2: ChartData[] = [
  {
    label: 'dataset 1',
    borderColor: colors.gray['400'],
    values: monthsLabels.map(() =>
      faker.datatype.number({ min: 0, max: 150000 }),
    ),
  },
  {
    label: 'dataset 2',
    borderColor: colors.blue['200'],
    values: monthsLabels.map(() =>
      faker.datatype.number({ min: 0, max: 150000 }),
    ),
  },
];

export const CardsExamples: React.FC = () => {
  const [picked1, setPicked1] = useState();
  const [picked2, setPicked2] = useState('Dados 1');
  const [picked3, setPicked3] = useState('Linha');
  const [selected, setSelected] = useState();
  const [selectedFilter, setSelectedFilter] = useState();
  const [date, setDate] = useState<
    { startDate: Date; endDate: Date; key: string }[] | undefined
  >();

  useEffect(() => {
    console.log(picked1);
    console.log(picked2);
  }, [picked1, picked2]);

  useEffect(() => {
    console.log(selected);
  }, [selected]);

  useEffect(() => {
    console.log(selectedFilter);
  }, [selectedFilter]);

  useEffect(() => {
    console.log(date);
  }, [date]);

  return (
    <VStack flex={1} bg="#F5F5F5" p="16px">
      <MultiInfoCard
        title={homeCardsData.MultiInfoData1.title}
        subtitle={homeCardsData.MultiInfoData1.subtitle}
        picker={['a', 'b', 'c']}
        setPicked={setPicked1}
        details={homeCardsData.MultiInfoData1.details}
        data={homeCardsData.MultiInfoData1.data}
        w="100%"
      />
      <ChartCard
        title={homeCardsData.MultiInfoData3.title}
        subtitle={homeCardsData.MultiInfoData3.subtitle}
        hasFilter={homeCardsData.MultiInfoData3.hasFilter}
        setDateRange={setDate}
        picker={['Dados 1', 'Dados 2']}
        setPicked={setPicked2}
        filters={ChartTypeFilters}
        setFilter={setSelectedFilter}
        details={homeCardsData.MultiInfoData3.details}
        w="100%"
      >
        <Box w="100%" overflowX="auto">
          <LineChart
            w="500px"
            labels={picked2 === 'Dados 1' ? daysLabels : monthsLabels}
            data={picked2 === 'Dados 1' ? lineData : lineData2}
          />
        </Box>
      </ChartCard>
      <ChartCard
        title={homeCardsData.MultiInfoData3.title}
        subtitle={homeCardsData.MultiInfoData3.subtitle}
        hasFilter={homeCardsData.MultiInfoData3.hasFilter}
        picker={['Linhas', 'Barras', 'Multi']}
        setPicked={setPicked3}
        details={homeCardsData.MultiInfoData3.details}
        w="100%"
      >
        <Box w="100%" overflowX="auto">
          {picked3 === 'Linhas' ? (
            <LineChart labels={testLabels} data={lineDataWithDefaultColors} />
          ) : picked3 === 'Barras' ? (
            <BarChart
              w="500px"
              labels={testLabels}
              data={barDataWithBorderColorAndColorArray}
            />
          ) : (
            <MultiChart
              labels={testLabels}
              data={multiChartDefaultColorsLinesAndBars}
              type="bar"
            />
          )}
        </Box>
      </ChartCard>
      <MapCard
        w="100%"
        select={[
          'Brasil',
          'Sudeste',
          'Sul',
          'Norte',
          'Nordeste',
          'Centro-Oeste',
        ]}
        setSelected={setSelected}
        hasMap
        hasBars
        title="Regiões por Idade e Km - Brasil"
        subtitle="A Idade e Km da sua frota dividida pelo Brasil."
        data={selected === 'Sudeste' ? MapValue3 : MapValue1}
      />
      <TableCard
        fetchDownload={() => console.log('download')}
        hasActions
        hasGlobalSearch
        customTitle={
          <Text
            alignSelf="center"
            color="text.100"
            fontSize="16px"
            fontWeight={400}
          >
            Entrada e Saída de <b>Manutenções</b>
          </Text>
        }
        subtitle="Comparativo sobre a relação entre entrada e saída de
        veículos em manutenções"
        overflowX="auto"
        w="100%"
        filters={tableFilters}
        labels={testTableLabels}
        data={testTableData(100)}
      />
    </VStack>
  );
};
